import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { ConfirmacionComponent } from 'src/app/home/confirmacion/confirmacion.component';
import { AlarmaConfirmacionDialogComponent } from '../alarma-confirmacion-dialog/alarma-confirmacion-dialog.component';
import { AlarmaTransferirDialogComponent } from '../alarma-transferir-dialog/alarma-transferir-dialog.component';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';

@Component({
  selector: 'app-alarma-detalle-dialog',
  templateUrl: './alarma-detalle-dialog.component.html',
  styleUrls: ['./alarma-detalle-dialog.component.scss']
})
export class AlarmaDetalleDialogComponent {

  comentario: string = '';
  zoomLevel: number = 1;
  historialWa: any = null;
  logsWa: any[] = [];
  loadingWa = false;
  showWaDetail = false;

  zoomIn() {
    this.zoomLevel += 0.2;
  }

  zoomOut() {
    if (this.zoomLevel > 0.4) {
      this.zoomLevel -= 0.2;
    }
  }

  resetZoom() {
    this.zoomLevel = 1;
  }

  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<AlarmaDetalleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private localsave: LocalSaveService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private gateway: GatewayService,
  ) { }

  ngOnInit() {
    const controls: any = {
      comentario: [this.data.comentario_agente ? this.data.comentario_agente : '', Validators.required]
    };
    // tipo=4 "Cambio de equipo": al aprobar hay que escribir el numero de orden
    // de instalacion que se creo. Lo hacemos requerido del formulario.
    if (Number(this.data.tipo_escenario) === 4) {
      // Orden de instalacion: exactamente 7 caracteres (formato de orden, p.ej. J00000A).
      controls.orden_instalacion = ['', [Validators.required, Validators.pattern(/^[A-Za-z0-9]{7}$/)]];
    }
    this.form = this.fb.group(controls);
    this.cargarHistorialWa();
  }

  cargarHistorialWa() {
    if (!this.data || !this.data.id_cita) return;
    this.loadingWa = true;
    this.gateway.get('historialWhatsappInfructuosa', { idCita: this.data.id_cita })
        .then((res: any) => {
            this.loadingWa = false;
            if (res && res.response === 1 && res.seguimiento) {
                this.historialWa = res.seguimiento;
                this.logsWa = res.logs || [];
            }
        })
        .catch(() => { this.loadingWa = false; });
  }

  getEstadoWaColor(estado: string): string {
    switch (estado) {
        case 'ACTIVO': return '#FF9800';
        case 'REAGENDADO': return '#4CAF50';
        case 'EXPIRADO': return '#9E9E9E';
        case 'CANCELADO': return '#F44336';
        default: return '#9E9E9E';
    }
  }

  cerrar() {
    this.dialogRef.close();
  }

  /**
   * mode:
   *  - 'aprobar' (infructuoso): dialog tipificacion infructuosa (accion=1)
   *  - 'rechazar' (infructuoso): confirmacion simple (accion=2)
   *  - 'orden_procede' (escalamiento): confirmacion simple (accion=1)
   *  - 'cerrar_orden' (escalamiento): dialog tipificacion infructuosa (accion=1)
   *  - undefined + accion=3 (gestionar): cierra directo
   */
  resolver(accion: number, mode?: string) {
    if (Number(accion) === 3) {
      // Gestionar cliente: no pedimos re-tipificacion
      this.dialogRef.close({
        accion,
        comentario: this.form.value.comentario
      });
      return;
    }

    // tipo=4 "Cambio de equipo" APROBADO: requiere comentario + numero de orden
    // de instalacion. No tipifica ni cierra orden; el backend crea la cita de
    // instalacion clonando la de reparacion.
    if (mode === 'cambio_equipo_aprobar') {
      const orden = (this.form.value.orden_instalacion || '').trim();
      if (!orden) {
        this.snackbar.open('Ingresá el número de orden de instalación.', 'Cerrar', { duration: 3000 });
        return;
      }
      const dialogRef = this.dialog.open(ConfirmacionComponent, {
        disableClose: true,
        width: '360px',
        data: { sms: 'APROBAR el cambio de equipo y crear la cita de instalación', addcomment: false }
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.resp) {
          this.dialogRef.close({
            accion: 1,
            comentario: this.form.value.comentario,
            orden_instalacion: orden
          });
        }
      });
      return;
    }

    // Los flujos con tipificacion: "aprobar" (infructuoso) y "cerrar_orden" (escalamiento)
    const requiereTipificacion = mode === 'aprobar' || mode === 'cerrar_orden';

    if (requiereTipificacion) {
      // Dialog con cascada de tipologias (siempre nivelcontacto infructuoso 1 y 2)
      const dialogRef = this.dialog.open(AlarmaConfirmacionDialogComponent, {
        disableClose: true,
        width: '480px',
        data: {
          accion,
          mode,
          id_cita: this.data.id_cita,
          idtipologia_actual: this.data.idtipologia,
          idsubtipologia_actual: this.data.idsubtipologia,
          // Razon original de la alarma (id_reason) o la del agente si ya fue
          // tipificada antes (idrazon_agente). Permite preseleccionar el tercer
          // dropdown "Razon" del dialog de confirmacion.
          idrazon_actual: this.data.idrazon_agente || this.data.id_reason || null,
          tipo_gestion: 1,  // siempre infructuosa para los flujos de resolucion
          id_contrata: this.data.cita_id_contrata  // 41 Orden / 44 Falla
        }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.resp) {
          this.dialogRef.close({
            accion,
            comentario: this.form.value.comentario,
            idtipologia_agente: result.idtipologia_agente,
            idsubtipologia_agente: result.idsubtipologia_agente,
            idrazon_agente: result.idrazon_agente
          });
        }
      });
    } else {
      // Confirmacion simple: "rechazar" o "orden_procede"
      let mensaje = 'RECHAZAR la solicitud';
      if (mode === 'orden_procede') {
        const esOrden = Number(this.data.cita_id_contrata) === 41;
        mensaje = esOrden ? 'marcar como ORDEN PROCEDE' : 'marcar como FALLA PROCEDE';
      }
      const dialogRef = this.dialog.open(ConfirmacionComponent, {
        disableClose: true,
        width: '350px',
        data: { sms: mensaje, addcomment: false }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result.resp) {
          this.dialogRef.close({
            accion,
            comentario: this.form.value.comentario
          });
        }
      });
    }
  }

  /**
   * "Liberar y reintentar" (No Localizado / Ausente en banda AM): libera al técnico
   * y devuelve la orden al pool como reintentable. Requiere confirmación.
   */
  liberarYReintentar() {
    const dialogRef = this.dialog.open(ConfirmacionComponent, {
      disableClose: true,
      width: '360px',
      data: { sms: 'LIBERAR al técnico y reintentar la orden más tarde', addcomment: false }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.resp) {
        this.dialogRef.close({
          accion: 1,
          liberar_reintento: true,
          idsubtipologia_agente: this.data.idsubtipologia,
          comentario: this.form.value.comentario
        });
      }
    });
  }

  /**
   * Abre el dialog de transferencia. Al confirmar cierra el detalle con
   * accion=4 y los ids de area destino + re-tipificacion.
   * No requiere que el comentario este lleno (aunque si esta lo envia).
   */
  transferir() {
    const dialogRef = this.dialog.open(AlarmaTransferirDialogComponent, {
      disableClose: true,
      width: '480px',
      data: {
        id_cita: this.data.id_cita,
        area_id: this.data.area_id || null,
        tipo_escenario: this.data.tipo_escenario || null
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.resp) {
        this.dialogRef.close({
          accion: 4, // transferida
          comentario: this.form.value.comentario || null,
          idareaagente_destino: result.idareaagente_destino,
          idtipologia_agente: result.idtipologia_agente,
          idsubtipologia_agente: result.idsubtipologia_agente,
          idrazon_agente: result.idrazon_agente
        });
      }
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  /**
   * Devuelve "lat, lng" si ambos vienen, sino null.
   */
  ubicacionTecnico(): string | null {
    const lat = this.data && this.data.tecnico_latitud;
    const lng = this.data && this.data.tecnico_longitud;
    if (lat === null || lat === undefined || lat === '' ||
        lng === null || lng === undefined || lng === '') {
      return null;
    }
    return `${lat}, ${lng}`;
  }

  /**
   * Copia "lat, lng" al portapapeles. Mismo patron que en alerta-flotante.
   */
  copiarUbicacion(): void {
    const texto = this.ubicacionTecnico();
    if (!texto) {
      this.snackbar.open('El tecnico no tiene ubicacion registrada', 'Cerrar', { duration: 2500 });
      return;
    }
    const okMsg = 'Ubicacion copiada: ' + texto;
    if (navigator && (navigator as any).clipboard && (navigator as any).clipboard.writeText) {
      (navigator as any).clipboard.writeText(texto)
        .then(() => this.snackbar.open(okMsg, 'Cerrar', { duration: 2500 }))
        .catch(() => this.copiarConFallback(texto, okMsg));
    } else {
      this.copiarConFallback(texto, okMsg);
    }
  }

  private copiarConFallback(texto: string, okMsg: string) {
    try {
      const ta = document.createElement('textarea');
      ta.value = texto;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      this.snackbar.open(okMsg, 'Cerrar', { duration: 2500 });
    } catch (e) {
      this.snackbar.open('No se pudo copiar la ubicacion', 'Cerrar', { duration: 3000 });
    }
  }

}
